var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocked(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M3.88544 4.52734C3.68447 4.52734 3.52148 4.69026 3.52148 4.8913C3.52148 5.02608 3.59496 5.14347 3.70388 5.20643V5.61106H4.067V5.20643C4.17593 5.1435 4.2494 5.02608 4.2494 4.8913C4.2494 4.69026 4.08644 4.52734 3.88544 4.52734Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M3.88484 2.76172C3.57891 2.76172 3.33008 3.01057 3.33008 3.31648V3.90727H4.43955V3.31648C4.43953 3.01062 4.1907 2.76172 3.88484 2.76172Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M3.88471 0.757812C1.95177 0.757812 0.384766 2.32486 0.384766 4.25781C0.384766 6.19071 1.95177 7.75781 3.88471 7.75781C5.81765 7.75781 7.38477 6.19069 7.38477 4.25781C7.38477 2.32486 5.81765 0.757812 3.88471 0.757812ZM4.96016 6.05732H2.80942C2.58229 6.05732 2.39814 5.87316 2.39814 5.64596V4.31783C2.39814 4.1197 2.53831 3.95424 2.72488 3.91532V3.31571C2.72488 2.67615 3.24522 2.15576 3.88482 2.15576C4.52438 2.15576 5.04472 2.67611 5.04472 3.31571V3.91532C5.23123 3.95436 5.37139 4.1197 5.37139 4.31783V5.64596H5.37144C5.37144 5.87314 5.18729 6.05732 4.96016 6.05732Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/locked.f0d891d55b47aedca08a7562bad04957.svg";
export { ForwardRef as ReactComponent };